import { Link } from "react-router-dom";
import { OVAMX_LOGO } from "@/lib/brand";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function Logo({ size = 36, className = "", showWordmark = true, asLink = true }) {
  const { config } = useSiteConfig();
  const logoSrc = config?.brand?.logo_url || OVAMX_LOGO;
  const name = config?.brand?.name || "Ovamx";
  const content = (
    <>
      <img
        src={logoSrc}
        alt={name}
        width={size}
        height={size}
        className="rounded-lg object-contain"
        style={{ width: size, height: size }}
      />
      {showWordmark && (
        <span className="font-serif text-2xl tracking-tighter leading-none text-ink group-hover:text-coral transition-colors">
          {name}
        </span>
      )}
    </>
  );
  const cls = `inline-flex items-center gap-2.5 group ${className}`;
  if (!asLink) {
    return <span data-testid="ovamx-logo" className={cls}>{content}</span>;
  }
  return (
    <Link to="/" data-testid="ovamx-logo" className={cls}>
      {content}
    </Link>
  );
}
